module.exports = __webpack_public_path__ + "static/img/banner.18375e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/banner.png
// module id = 974
// module chunks = 41